(function () {
	const imagebanner = () => {
		const paralax = document.querySelector(".image-banner");
    if ( paralax.classList.contains("slider_started")) {
      return;
    }
    paralax.classList.add("slider_started");
		const section = document.querySelector('.image-banner');
		const img = document.querySelector('.image-banner__img');


	};
	
	
	imagebanner();

	document.addEventListener("shopify:section:load", function () {
		imagebanner();
	});
})();
